import { useState } from "react";

import ImagePolicy01 from "../../../assets/policies/policy_guide_01.png";
import ImagePolicy04 from "../../../assets/policies/policy_guide_04.png";
import ImagePolicy06 from "../../../assets/policies/policy_guide_06.png";
import ImagePolicy11 from "../../../assets/policies/policy_guide_11.png";
import ImagePolicy12 from "../../../assets/policies/policy_guide_12.png";

import PayWithVNPayQR from "./PayWithVNPayQR";
import PayWithBankCard from "./PayWithBankCard";
import { useTranslation } from "react-i18next";

const PaymentPolicy = () => {
  const { t } = useTranslation();

  const [payments, setPayments] = useState([
    {
      active: true,
      method: t("policy.payment.method1"),
      component: <PayWithVNPayQR />,
    },
    {
      active: false,
      method: t("policy.payment.method2"),
      component: <PayWithBankCard />,
    },
    {
      active: false,
      method: t("policy.payment.method3"),
      component: (
        <span className="w-[90%] p-4 mt-8 text-lg rounded-xl font-bold bg-white lg:w-full">
          {t("policy.payment.method3_content")}
        </span>
      ),
    },
    {
      active: false,
      method: t("policy.payment.method4"),
      component: (
        <span className="w-[90%] p-4 mt-8 text-lg rounded-xl font-bold bg-white lg:w-full">
          {t("policy.payment.method4_content")}
        </span>
      ),
    },
  ]);

  const handleOnChangePaymentMethod = (index: number) => {
    for (let i = 0; i < payments.length; i++) {
      if (i === index) {
        payments[index].active = true;
      } else {
        payments[i].active = false;
      }
    }

    setPayments([...payments]);
  };

  return (
    <div className="h-auto w-full flex flex-col gap-14">
      <div className="flex flex-col gap-5">
        <h1 className="uppercase text-3xl font-bold">
          {t("policy.payment.title")}
        </h1>
        <span className="text-justify font-normal leading-8">
          {t("policy.payment.intro")}
        </span>
        <p>
          Fees are outlined on our website and include applicable taxes,
          consular charges, and delivery fees. TRAVERSIA’s service fees are
          non-refundable once documentation has been submitted to the issuing
          authority.
        </p>
        <p>Additional fees may apply for:</p>
        <ul className="list-disc list-inside">
          <li>Resubmissions due to customer error.</li>
          <li>Cancellation of passport reservations.</li>
          <li>Offline or non-standard orders.</li>
        </ul>
        <p>
          Consular fees and service availability may change without notice, and
          TRAVERSIA will notify you when possible.
        </p>
      </div>
      <div className="flex flex-col justify-center items-center">
        <span className="text-2xl mb-4 fond-bold text-center">
          {t("policy.payment.section1.title")}
        </span>
        <img
          src={ImagePolicy11}
          alt="Bank Connect"
          className="w-full h-auto max-w-[1320px] max-h-[300px]"
        />
        <img
          src={ImagePolicy12}
          alt="Bank Connect"
          className="w-full h-auto max-w-[1320px] max-h-[300px]"
        />
      </div>
      <div className="w-full flex flex-col justify-center items-center">
        <span className="text-2xl mb-4 fond-bold text-center">
          {t("policy.payment.section2.title")}
        </span>
        <img
          src={ImagePolicy04}
          alt="Bank Connect"
          className="w-full h-auto max-w-[1725px] max-h-[650px]"
        />
      </div>
      <div className="w-full flex flex-col justify-center items-center">
        <span className="text-2xl mb-4 fond-bold text-center">
          {t("policy.payment.section3.title")}
        </span>
        <img
          src={ImagePolicy01}
          alt="Bank Connect"
          className="w-full h-auto max-w-[850px] max-h-[103px]"
        />
      </div>
      <div className="w-full flex flex-col justify-center items-center">
        <span className="text-2xl mb-4 fond-bold text-center">
          {t("policy.payment.section4.title")}
        </span>
        <img
          src={ImagePolicy06}
          alt="Bank Connect"
          className="w-full h-auto max-w-[806px] max-h-[650px]"
        />
      </div>
      <div className="w-full flex flex-col lg:flex-row justify-evenly mb-4">
        {payments.map((payment, index) => {
          return (
            <span
              key={index}
              className={`py mb-2 px-4 py-2 rounded-lg w-fit cursor-pointer text-xl lg:mb-0 ${
                payment.active ? "lg:scale-105 shadow-xl border-2" : ""
              }`}
              onClick={() => {
                handleOnChangePaymentMethod(index);
              }}
            >
              {payment.method}
            </span>
          );
        })}
      </div>
      <div className="flex items-center justify-center">
        {payments.map((payment) => payment.active && payment.component)}
      </div>
      <div className="w-[80%] my-12 mx-auto text-center border-b-2"></div>
      <div className="flex flex-col items-center justify-center text-black">
        <h2 className="mb-12 text-2xl font-bold">
          {t("policy.payment.support_channel.title")}
        </h2>
        <ul>
          <li className="mb-2 flex justify-between">
            <span className="w-24 mr-8">
              {t("policy.payment.support_channel.email")}
            </span>
            <span>hotro@vnpay.vn</span>
          </li>
          <li className="mb-2 flex justify-between">
            <span className="w-24 mr-8">
              {t("policy.payment.support_channel.switchboard")}
            </span>
            <span>*3388 or 1900 55 55 77</span>
          </li>
          <li className="mb-2 flex justify-between">
            <span className="w-24 mr-8">
              {t("policy.payment.support_channel.zalo")}
            </span>
            <span>zalo.me/4134983655549474109</span>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default PaymentPolicy;
